import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import MainLayout from '@/components/layouts/MainLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import PasswordUpdateForm from '@/components/auth/PasswordUpdateForm';

const AdminAccountSettings = () => {
  const { profile } = useAuth();
  const { toast } = useToast();
  
  const handleSaveChanges = () => {
    toast({
      title: "Settings saved",
      description: "Your account settings have been updated successfully.",
    });
  };
  
  return (
    <MainLayout>
      <div className="container mx-auto max-w-3xl py-6">
        <h1 className="text-2xl font-bold mb-6 text-black dark:text-white">Account Settings</h1>
        
        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Profile Information</CardTitle>
            <CardDescription>Update your account profile information</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="space-y-2">
                  <Label htmlFor="name">Name</Label>
                  <Input id="name" defaultValue={profile?.name || ''} />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" defaultValue={profile?.email || ''} readOnly />
                  <p className="text-sm text-muted-foreground">Email cannot be changed</p>
                </div>
              </div>
              
              <Button onClick={handleSaveChanges} className="bg-brand-500 hover:bg-brand-600">
                Save Changes
              </Button>
            </div>
          </CardContent>
        </Card>
        
        <Card className="mb-6">
          <CardHeader>
            <CardTitle>Appearance</CardTitle>
            <CardDescription>Customize how the application looks</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium">Theme</h3>
                <p className="text-sm text-muted-foreground">Select your preferred theme</p>
              </div>
              <ThemeToggle />
            </div>
          </CardContent>
        </Card>
        
        <PasswordUpdateForm />
      </div>
    </MainLayout>
  );
};

export default AdminAccountSettings;
